import { useEffect, useRef, useState } from "react";

/** Desktop-only gold cursor with easing follow + magnetic snap on links/buttons. */
export default function CustomCursor() {
  const dot = useRef(null);
  const [enabled, setEnabled] = useState(false);
  const state = useRef({ x: -100, y: -100, tx: -100, ty: -100, s: 1, ts: 1, mx: null, my: null });

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return undefined;
    setEnabled(true);
    document.documentElement.classList.add("custom-cursor-on");

    const st = state.current;
    const onMove = (e) => {
      st.tx = e.clientX;
      st.ty = e.clientY;
    };
    const onOver = (e) => {
      const t = e.target.closest("a, button, [data-magnetic]");
      if (!t) return;
      const r = t.getBoundingClientRect();
      st.mx = r.left + r.width / 2;
      st.my = r.top + r.height / 2;
      st.ts = 2.2;
    };
    const onOut = (e) => {
      if (e.target.closest("a, button, [data-magnetic]")) {
        st.mx = null;
        st.my = null;
        st.ts = 1;
      }
    };

    window.addEventListener("mousemove", onMove);
    document.addEventListener("mouseover", onOver);
    document.addEventListener("mouseout", onOut);

    let raf;
    const loop = () => {
      const gx = st.mx ?? st.tx;
      const gy = st.my ?? st.ty;
      st.x += (gx - st.x) * 0.18;
      st.y += (gy - st.y) * 0.18;
      st.s += (st.ts - st.s) * 0.15;
      if (dot.current) {
        dot.current.style.transform = `translate3d(${st.x - 12}px, ${st.y - 12}px, 0) scale(${st.s})`;
      }
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    return () => {
      document.documentElement.classList.remove("custom-cursor-on");
      cancelAnimationFrame(raf);
      window.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseover", onOver);
      document.removeEventListener("mouseout", onOut);
    };
  }, []);

  if (!enabled) return null;

  return (
    <div
      ref={dot}
      data-testid="custom-cursor"
      className="pointer-events-none fixed left-0 top-0 z-[110] h-6 w-6 rounded-full border border-gold bg-gold/15"
      style={{ willChange: "transform" }}
    />
  );
}
